<template>
  <span
    class="def-price-delivery"
    :class="{ 'def-price-delivery_free': props.result.price === 0 }"
    >{{ props.result.printPrice }}</span
  >
</template>

<script lang="ts" setup>
import { IPrice } from '@/interfaces/IProduct/IPrice';

const props = defineProps<{ result: IPrice }>();
</script>

<style lang="scss" scoped>
.def-price-delivery {
  color: var(--color-main);
  font-weight: 700;
  line-height: 125%;
  &_free {
    color: var(--color-green);
  }
}
</style>
